import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Button from '../../BuildingBlocks/Button/Button';

const useStyles = makeStyles((theme: any) => ({
  contentSection: {
    display: 'inline-block',
  },
  attributesSection: {
    width: '100%',
    marginRight: theme.spacing(3),
  },
  contentRow: {
    height: theme.spacing(5),
    whiteSpace: 'nowrap',
    width: '100%',
    marginBottom: theme.spacing(2.5),
    '& .MuiTypography-root': {
      lineHeight: `${theme.spacing(5)}px`,
    },
  },
  contentWrapper: {
    paddingLeft: theme.spacing(3),
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(1.5),
    paddingRight: theme.spacing(2.5),
    display: 'flex',
    alignItems: 'flex-start',
  },
  attributeRow: {
    background: '#fff',
    borderRadius: theme.spacing(1),
    paddingRight: theme.spacing(1.5),
    paddingLeft: theme.spacing(1.5),
  },
  button: {
    borderRadius: theme.spacing(1.5),
    fontSize: theme.spacing(2),
  },
}));

interface ButtonDescription {
  id: string;
  label: string;
  callback: () => void;
}

interface ButtonsMap {
  [id: string]: ButtonDescription;
}

interface AttributeDescription {
  label: string;
  value: string | JSX.Element;
  class?: string;
}

interface AttributesMap {
  [id: string]: AttributeDescription;
}

interface ButtonsMapProps {
  buttonsMap: ButtonsMap;
}
interface AttributesListProps {
  attributesMap: AttributesMap;
}

interface CardContentProps {
  buttonsMap: ButtonsMap;
  attributesMap: AttributesMap;
  buttonsWrapClass?: string;
}

function AttributesList(props: AttributesListProps) {
  const classes = useStyles();
  const { attributesMap } = props;
  return (
    <>
      {Object.values(attributesMap).map((attr: AttributeDescription) => {
        const extraClasses = attr.class || '';
        return (
          <Grid
            key={attr.label}
            container
            justifyContent="space-between"
            direction="row"
            wrap="nowrap"
            className={`${classes.contentRow} ${classes.attributeRow}`}
          >
            <Typography variant="subtitle2" style={{ fontWeight: 700 }}>
              {attr.label}:
            </Typography>
            <Typography variant="subtitle2" className={extraClasses}>
              {attr.value}
            </Typography>
          </Grid>
        );
      })}
    </>
  );
}

function ButtonsList(props: ButtonsMapProps) {
  const classes = useStyles();
  const { buttonsMap } = props;
  return (
    <>
      {Object.values(buttonsMap).map((button: ButtonDescription) => {
        const { id, label, callback } = button;
        return (
          <Button
            key={id}
            className={`${classes.contentRow} ${classes.button}`}
            color="primary"
            variant="contained"
            onClick={callback}
          >
            {label}
          </Button>
        );
      })}
    </>
  );
}

export default function CardContent({
  buttonsMap,
  attributesMap,
  buttonsWrapClass = '',
}: CardContentProps) {
  const classes = useStyles();
  return (
    <div className={classes.contentWrapper}>
      <div className={`${classes.contentSection} ${classes.attributesSection}`}>
        <AttributesList attributesMap={attributesMap} />
      </div>
      <div className={`${classes.contentSection} ${buttonsWrapClass}`}>
        <ButtonsList buttonsMap={buttonsMap} />
      </div>
    </div>
  );
}
